import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Spin } from 'antd';
import axios from "axios";
import React from "react";

import brandLogo from "../../assets/images/satisfi_white.svg";
import constants from "../../constants";
import SignIn from "../../containers/SignIn";

const contentStyle = {
	padding: 50,
	borderRadius: 4
};

const content = <div style={contentStyle} />;

class SSORedirection extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			status: "validating",
			error: ""
		};
	}

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);
		const token = params.get("token");

		if (!token) {
			this.setState({ status: "error", error: "Authorization token missing" });
			return;
		}

		axios({
			method: "GET",
			url: `${constants.ssoLogin}?token=${token}`
		}).then(res => {
			this.pageRedirection(res.data);
		}).catch(error => {
			if (error?.response?.data?.message) {
				this.setState({ status: "error", error: error.response.data.message });
			}
		})
	}

	render() {
		const { status, error } = this.state;
		return (
			<div
				style={{
					height: '100vh',
					overflow: 'hidden',
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<div className="base" style={{ padding: '16px 0' }}>
					<div
						style={{
							width: 220,
							marginLeft: 16,
						}}
					>
						<img
							src={brandLogo}
							alt="Logo"
							style={{ height: "30px", width: "auto" }}
						/>
					</div>
				</div>

				<div style={{ marginTop: "50px" }}>
					{status === "validating" ? (
						<div className="sso-verifying-token">
							<Spin tip="Verifying credentials..." indicator={<LoadingOutlined spin />} size="large" style={{ color: "#27272F", fontSize: "18px" }}>{content}</Spin>
						</div>
					) : null}
					{status === "error" ? (
						<>
							<div className="sso-token-expired">
								<Alert
									message={error || "Token expired or invalid"}
									description="Please log in with your email and password to continue"
									type="error"
								/>
							</div>
							<SignIn />
						</>
					) : null}
				</div>
			</div>
		);
	}

	pageRedirection = async (response) => {
		this.setState({ loading: true });
		//storing the user_token
		window.localStorage.setItem("id", response.user.id);
		window.localStorage.setItem("user_token", response.jwt);
		window.localStorage.setItem("username", response.user.username);
		window.localStorage.setItem("firstname", response.user.firstname || response.user.username);
		window.localStorage.setItem("email", response.user.email);
		response.user.enterprise
			? window.localStorage.setItem(
				"enterprise_id",
				response.user.enterprise.id,
			)
			: null;
		if (response.user.enterprise) {
			window.localStorage.setItem(
				"org_name",
				response.user.enterprise.org_name,
			);
		} else {
			window.localStorage.setItem("org_name", "Enterprise Name");
		}
		const claims_req = {
			method: "GET",
			url: constants.claims,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${response.jwt}`,
			},
		};

		const claims_resp = await axios(claims_req);

		let MAIN_DASH = true;
		let DNS_VALIDATION = true;

		if ([200, 201].includes(claims_resp.status)) {
			if (claims_resp.data?.data && claims_resp.data.data.length > 0) {
				for (const claim of claims_resp.data.data) {
					if (claim.feature === "MAIN_DASH" && claim.disabled) {
						MAIN_DASH = false;
					} else if (claim.feature === "DNS_VALIDATION" && claim.disabled) {
						DNS_VALIDATION = false;
					}
				}
			}
		}

		/**
		 * set claims in localstorage
		 */
		window.localStorage.setItem("MAIN_DASH", MAIN_DASH.toString());
		window.localStorage.setItem("DNS_VALIDATION", DNS_VALIDATION.toString());

		if (response.user.enterprise) {
			window.localStorage.setItem(
				"factcube_enabled",
				response.user.enterprise.factcube_enabled !== undefined
					? response.user.enterprise.factcube_enabled
					: false,
			);

			window.localStorage.setItem(
				"dash_currency",
				response.user.enterprise.currency !== null
					? response.user.enterprise.currency
					: "$",
			);
		}
		window.location.replace(window.location.origin);
		this.setState({ loading: false });
	};

}

export default SSORedirection;
